<template>
  <div ref="quantidadeNovosPagantesDiaChart" @update-charts="update" />
</template>

<script>
import ApexCharts from 'apexcharts';
import { i18n } from '@/modules/localization/index.js';
import eventbus from '@/modules/core/services/eventbus';
import estatisticasChartsDefaultOptions from './estatisticasChartsDefaultOptions';
export default {
  props: {
    loading: { type: Boolean, required: true },
  },
  data: () => ({
    quantidadeNovosPagantesDiaChart: null,
    options: estatisticasChartsDefaultOptions,
  }),
  mounted() {
    this.quantidadeNovosPagantesDiaChart = new ApexCharts(this.$refs.quantidadeNovosPagantesDiaChart, this.options);
    this.quantidadeNovosPagantesDiaChart.render();
    eventbus.on('update-charts', this.update);
  },
  unmounted() {
    this.quantidadeNovosPagantesDiaChart.destroy();
    eventbus.off('update-charts', this.update);
  },
  methods: {
    async update(chartsData) {
      const x = chartsData.quantidadeNovosPagantesDia.map((x) => x.dia);
      const y = chartsData.quantidadeNovosPagantesDia.map((x) => x.quantidade);
      this.quantidadeNovosPagantesDiaChart.updateOptions({
        chart: {
          type: 'bar',
        },
        plotOptions: {
          bar: {
            borderRadius: 2,
            horizontal: false,
          },
        },
        title: {
          text: i18n.global.t('quantidadeNovosPagantesDia'),
        },
        subtitle: {
          text: i18n.global.t('total') + (chartsData.totalNovosPagantes != null ? chartsData.totalNovosPagantes : 0),
        },
        series: [{ data: y }],
        xaxis: { categories: x },
      });
    },
  },
};
</script>
